<template>
  <el-table-column
    :key="code"
    :label="name"
    :min-width="200"
    :fixed="false"
    align="center"
  >
    <template
      #default="scope"
    >
      <!-- 编辑模式 -->
      <ik-table-number
        v-show="edit"
        :ref="'input_' + scope.$index + '_' + 'code'"
        v-model="scope.row[code]"
        :line="scope.$index"
        :code="code"
        :name="name"
        :default-value="defaultValue"
        :precision="precision"
        :min="min"
        :max="max"
        :step="step"
        :require="getRequire"
        :rules="rules"
        @onFieldChange="onFieldChange"
      />
      <!-- 显示 -->
      <ik-table-number-tag
        v-show="!edit"
        :value="scope.row[code]"
        :precision="precision"
        :error-sign="errorSign[scope.$index]"
        :message="message[scope.$index]"
      />
    </template>
  </el-table-column>
</template>

<script>
import IkTableNumber from '@/components/ik/table/input/IkTableNumber'
import IkTableNumberTag from '@/components/ik/table/input/IkTableNumberTag'
export default {
  name: 'IkColumnNumber',
  components: {
    IkTableNumber,
    IkTableNumberTag
  },
  model: {
    // 属性
    prop: 'value',
    // 事件
    event: 'input'
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    line: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    },
    edit: {
      type: Boolean,
      default: true
    },
    defaultValue: {
      type: Number,
      default: 0
    },
    precision: {
      type: Number,
      default: 2
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100000
    },
    minLength: {
      type: Number,
      default: 0
    },
    maxLength: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    require: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return [
        ]
      }
    }
  },
  data() {
    return {
      errorSign: [],
      message: []
    }
  },
  computed: {
    getRequire() {
      return this.require
    }
  },
  watch: {
  },
  methods: {
    onFieldChange(line, code, oldValue, value, errorSign, message) {
      this.$set(this.errorSign, line, errorSign)
      this.$set(this.message, line, message)
      this.$emit('onFieldChange', line, code, oldValue, value, errorSign, message)
    }
  }
}
</script>
<style scoped>
::v-deep.require> .el-input__inner{
  border: red 1px solid;
}
</style>
<style lang="scss" >
.el-form-item {
  margin-bottom: 12px;
  width: 100%;
}
.el-form-item__label {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-form-item__content {
  width: calc(100% - 180px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
